/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  ContactListItemDto,
  ContactRestService,
  ContactType,
  CostCenterRestService,
  PolicyReportingMethod,
  SystemVarsRestService,
} from '@gh/builder-shared-data';
import { DictionaryService, InitViewService } from '@gh/common-shared';
import { FilteredDataQuery, getSlicedData } from '@gh/core-data';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import {
  SystemVarsManager,
  systemVarsManagerFromDto,
  SystemVarsManagerStatistic,
  systemVarsManagerToDto,
} from './model/system-vars.model';

@Injectable()
export class SystemVarsManagerTabBusinessService implements InitViewService {
  constructor(private systemVarsRest: SystemVarsRestService,
              private costCenterRest: CostCenterRestService,
              private contactRest: ContactRestService,
              private dictionaries: DictionaryService) {
  }

  initView(): any {
    return {
      policyReportingMethodDict: this.dictionaries.getByEnum(PolicyReportingMethod),
      details: this.get(),
    };
  }

  get(): Observable<SystemVarsManager> {
    return this.systemVarsRest.getManager().pipe(map$(systemVarsManagerFromDto));
  }

  save(manager: SystemVarsManager): Observable<SystemVarsManager> {
    return this.systemVarsRest.updateManager(systemVarsManagerToDto(manager)).pipe(map$(systemVarsManagerFromDto));
  }

  getStatistic(): Observable<SystemVarsManagerStatistic> {
    return this.systemVarsRest.getManagerStatistic();
  }

  findCompaniesByName(query: FilteredDataQuery<string>): Observable<ContactListItemDto[]> {
    return this.contactRest.findAllAsDataSource({
      showInactive: false,
      autocomplete: true,
      name: query.filter,
      types: [ContactType.CreditorSupplier],
    }).select(query).pipe(map$(getSlicedData));
  }
}
